import React, { lazy } from "react";
const Dashboard = lazy(() => import("../pages/Dashboard"));
const NoPage = lazy(() => import("../pages/404"));
const Users = lazy(() => import("../pages/Users"));
const Projects = lazy(() => import("../pages/projects"));
const Invoices = lazy(() => import("../pages/Invoices"));
const InvoiceCreate = lazy(() => import("../pages/Invoices/create"));
const InvoiceStatus = lazy(() => import("../pages/Invoices/status"));
const Settings = lazy(() => import("../pages/Settings"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const Timesheet = lazy(() => import("../pages/Timesheet"));
const ProjectLine = lazy(() => import("../pages/ProjectLine"));
const TimesheetStatus = lazy(() => import("../pages/Timesheet/status"));
const AdminTimesheets = lazy(() => import("../pages/Timesheet/AdminTimesheets"));
const ExpenseAccounts = lazy(() => import("../pages/ExpenseAccount"));
const AdminInvoices = lazy(() => import("../pages/Invoices/AdminInvoiceLines"));
const ManagerInvoiceStatus = lazy(() => import("../pages/Invoices/ManagerInvoiceStatus"));
const Logs = lazy(() => import("../pages/Logs"));
const ImportedInvoices = lazy(() => import("../pages/Invoices/ImportedInvoices"));
const OcrProjectLines = lazy(() => import("../pages/Ocr/ProjectLines"));
const OcrInvoices = lazy(() => import("../pages/Ocr/Invoices"));
const Contracts = lazy(() => import("../pages/Contracts"));
const ExpenseOrgCodes = lazy(() => import("../pages/ExpenseOrgCode"));

export type NavDataTypes = {
  path: string
  component: React.ReactNode
  authRequire: boolean
}

export const Navigations: NavDataTypes[] = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    authRequire: true
  },
  {
    path: "/users",
    component: <Users />,
    authRequire: true
  },
  {
    path: "/projects",
    component: <Projects />,
    authRequire: true
  },
  {
    path: "/project-line",
    component: <ProjectLine />,
    authRequire: true
  },
  {
    path: '/accounts',
    component: <ExpenseAccounts />,
    authRequire: true
  },
  {
    path: '/expense-org-code',
    component: <ExpenseOrgCodes />,
    authRequire: true
  },
  {
    path: '/timesheets',
    component: <AdminTimesheets />,
    authRequire: true
  },
  {
    path: '/timesheet',
    component: <Timesheet />,
    authRequire: true
  },
  {
    path: '/timesheet/status/:id',
    component: <TimesheetStatus />,
    authRequire: true
  },
  {
    path: "/invoices",
    component: <Invoices />,
    authRequire: true
  },
  {
    path: "/invoice-lines",
    component: <AdminInvoices />,
    authRequire: true
  },
  {
    path: "/invoices/new",
    component: <InvoiceCreate />,
    authRequire: true
  },
  {
    path: "/invoices/edit/:id",
    component: <InvoiceCreate />,
    authRequire: true
  },
  {
    path: "/invoices/status/:id",
    component: <InvoiceStatus />,
    authRequire: true
  },
  {
    path: "/manager/invoice/status",
    component: <ManagerInvoiceStatus />,
    authRequire: false
  },
  {
    path: "/settings",
    component: <Settings />,
    authRequire: true
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
    authRequire: false
  },
  {
    path: "/reset-password/:id",
    component: <ResetPassword />,
    authRequire: false
  },
  {
    path: "/logs",
    component: <Logs />,
    authRequire: true,
  },
  {
    path: "/imported-invoices",
    component: <ImportedInvoices />,
    authRequire: true,
  },
  {
    path: "/ocr-project-lines",
    component: <OcrProjectLines />,
    authRequire: true,
  },
  {
    path: "/ocr-invoices",
    component: <OcrInvoices />,
    authRequire: true,
  },
  {
    path: "/contracts",
    component: <Contracts />,
    authRequire: true
  },
  {
    path: "*",
    component: <NoPage />,
    authRequire: false
  }
];
